module.exports = __webpack_public_path__ + "img/table-empty.45618ea2.png";